
    <body>
        <div class="container">
            <h1>Privacy Policy</h1>
            <p>Last updated: 2025</p>
            
            <h3>1. Introduction</h3>
            <p>This Privacy Policy explains how Landpoint collects, uses, and protects data when using our LinkedIn API integration to display company posts.</p>
            
            <h3>2. Information We Collect</h3>
            <p>Our application does not collect personal data from users. It only retrieves publicly available LinkedIn posts from our company’s LinkedIn page.</p>
            
            <h3>3. How We Use the Information</h3>
            <p>The data retrieved from LinkedIn is used solely for displaying company updates on our website.</p>
            
            <h3>4. Data Protection</h3>
            <p>We do not store or share LinkedIn data. API requests are made in real time, and no user data is retained.</p>
            
            <h3>5. Third-Party Services</h3>
            <p>This site may contain links to LinkedIn. We are not responsible for LinkedIn's privacy policies or practices.</p>
            
            <h3>6. Contact Us</h3>
            <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:trosen&#64;landpoint.net">trosen&#64;landpoint.net</a>.</p>
            
            <footer>
                &copy; Landpoint | All rights reserved.
            </footer>
        </div>
    </body>

